import React from "react";

import "./styles.less";
import { useTranslation } from "react-i18next";
import { Title } from "../../components/NewTitle";

export const JoinusWalfare = () => {
  const { t } = useTranslation();
  const walfare = [
    {
      title: t("joinus.salary.item1.title"),
      subtitle: t("joinus.salary.item1.subtitle"),
      imgUrl: "//files.authing.co/authing-website/walfare-icon-bonus.png",
    },
    {
      title: t("joinus.salary.item2.title"),
      subtitle: t("joinus.salary.item2.subtitle"),
      imgUrl: "//files.authing.co/authing-website/walfare-icon-option.png",
    },
    {
      title: t("joinus.salary.item3.title"),
      subtitle: t("joinus.salary.item3.subtitle"),
      imgUrl: "//files.authing.co/authing-website/walfare-icon-time.png",
    },
    {
      title: t("joinus.salary.item4.title"),
      subtitle: t("joinus.salary.item4.subtitle"),
      imgUrl: "//files.authing.co/authing-website/walfare-icon-food.png",
    },
    {
      title: t("joinus.salary.item5.title"),
      subtitle: t("joinus.salary.item5.subtitle"),
      imgUrl: "//files.authing.co/authing-website/walfare-icon-helth.png",
    },
    {
      title: t("joinus.salary.item6.title"),
      subtitle: t("joinus.salary.item6.subtitle"),
      imgUrl: "//files.authing.co/authing-website/walfare-icon-tuanjian.png",
    },
  ];
  return (
    <div>
      <section>
        <div className="joinus-walfare">
          <Title title={t("joinus.salary.title")} />
          <div className="joinus-walfare-warp">
            {walfare.map((item) => {
              return (
                <div className="joinus-walfare-item">
                  <div className="item-img">
                    <img src={item.imgUrl} alt="authing" />
                  </div>
                  <div className="item-text">
                    <div className="title">{item.title}</div>
                    <div className="subtitle">{item.subtitle}</div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </section>
    </div>
  );
};
